import { Box } from '@material-ui/core';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { BooleanInput } from 'components/standalone';

type AllowPayoutAmountEditingToggleProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  disabled?: boolean;
};

export const AllowPayoutAmountEditingToggle = <T extends FieldValues>({
  control,
  name,
  disabled,
}: AllowPayoutAmountEditingToggleProps<T>) => (
  <Box mt={2}>
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <BooleanInput
          label="Allow Payout Amount Editing"
          checked={!!field.value}
          onChange={field.onChange}
          disabled={disabled}
        />
      )}
    />
  </Box>
);
